import styled from 'styled-components'

import {colour, spacing, media, OntarioColumn} from '../../theme'

const FooterContainer = styled.footer`
  background-color: ${colour.palette.black};
  border-bottom: 4px solid ${colour.palette.greyscale70};
  color: ${colour.palette.white};
  padding: ${spacing.spacing9} ${spacing.spacing0};
  position: relative;
  z-index: 0;

  &:before {
    background-image: url('./images/footer-default-supergraphic-logo.svg');
    background-size: 112.5rem;
    background-position: calc(50vw - 73.5rem) -64rem;
    background-color: #333;
    background-repeat: no-repeat;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;

    @media ${media.small} {
      background-size: 180rem;
      background-position: calc(50vw - 120rem) -106rem;
    }

    @media ${media.medium} {
      background-size: 275rem;
      background-position: calc(50vw - 187rem) -160rem;
    }
  }

  @media print {
    display: none;
  }
`

const FooterColumn = styled(OntarioColumn)`
  position: relative;
  width: auto;

  *:last-child {
    margin-bottom: ${spacing.spacing0};
  }

  @media ${media.small} {
    margin-bottom: ${spacing.spacing8}

    &:last-of-type {
      margin-bottom: ${spacing.spacing0};
    }
  }
`

const FooterLinkContainer = styled.ul`
  list-style: none;
  margin: ${spacing.spacing0} ${spacing.spacing0} ${spacing.spacing4}
    ${spacing.spacing0};
  padding: ${spacing.spacing0};
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  li {
    padding: ${spacing.spacing1} ${spacing.spacing0};
  }

  @media ${media.medium} {
    margin-bottom: ${spacing.spacing2};
  }

  @media ${media.small} {
    flex-direction: row;
  }
`

const FooterLink = styled.a`
  color: ${colour.palette.white};
  display: inline-block;
  padding: ${spacing.spacing2} ${spacing.spacing0};
  margin: ${spacing.spacing0};
  text-decoration: underline;

  &:hover,
  &:focus {
    text-decoration: none;
  }

  &:visited,
  &:active,
  &:hover {
    color: ${colour.palette.white};
  }

  @media ${media.small} {
    padding: ${spacing.spacing0};
    margin: ${spacing.spacing0} ${spacing.spacing8} ${spacing.spacing4}
      ${spacing.spacing0};
  }
`

export {FooterContainer, FooterColumn, FooterLinkContainer, FooterLink}
